import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as actions from 'src/app/root-store/account-managers-submittals-store/actions';
import { showToasterMessage } from 'src/app/shared/actions/toaster.actions';
import { AccountManagersService } from 'src/app/accountmanagers/accountmanagers.service';
import { Store } from '@ngrx/store';
import { SubmittalClientNotesState } from '../state/submittals-clientnotes-state';
import { selectFilter } from '../selectors/submittals-clientnotes.selectors';

@Injectable()
export class SubmittalClientNotesEffects {
    loadASubmittalClientNotes$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.setSubmittalClientNotesFilter, actions.postSubmittalReplySuccess),
            concatLatestFrom(() => this.store$.select(selectFilter)),
            switchMap(([_, submittalIds]) => {
                return this.accountManagersService.getSubmittalClientNotes(submittalIds).pipe(
                    map((response) => actions.loadSubmittalClientNotesSuccess({ notes: response })),
                    catchError(() => of(actions.loadSubmittalClientNotesFail()))
                );
            })
        );
    });

    loadAccessControlCandidatesFail$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadSubmittalClientNotesFail),
            map(() => showToasterMessage({ message: 'Failed to load submittal client notes' }))
        );
    });

    postSubmittalReply$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.postSubmittalReply),
            switchMap((action) => {
                return this.accountManagersService.postSubmittalNoteReply(action.submittalId, action.replyParams).pipe(
                    map(() => actions.postSubmittalReplySuccess()),
                    catchError((error) => of(actions.postSubmittalReplyFail(error)))
                );
            })
        );
    });

    postSubmittalReplySuccess$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.postSubmittalReplySuccess),
            map(() => showToasterMessage({ message: 'Reply was successful' }))
        );
    });

    postSubmittalReplyFail$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.postSubmittalReplyFail),
            map(() => showToasterMessage({ message: 'Failed to post submittal reply' }))
        );
    });

    constructor(
        private readonly store$: Store<SubmittalClientNotesState>,
        private readonly actions$: Actions,
        private readonly accountManagersService: AccountManagersService
    ) {}
}
